var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.617,
    height: 36.602,
    viewBox: "0 0 39.617 36.602",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66",
    transform: "translate(-1528.667 -387.094)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(1528.667 387.094)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home-svgrepo-com_1_",
    "data-name": "home-svgrepo-com (1)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M19.955.793.146,20.6l.76.981L19.955,2.515,38.948,21.583l.816-.981ZM5.883,19.3V37.395H34.027V19.3H32.56V36.027H7.294V19.3Z",
    transform: "translate(-0.146 -0.793)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M252.6,350.742a1.521,1.521,0,1,0-1.746,0,2.674,2.674,0,0,0-1.574,1.471,2.674,2.674,0,0,0-1.576-1.471,1.521,1.521,0,1,0-1.746,0,2.665,2.665,0,0,0-1.787,2.512.213.213,0,0,0,.426,0,2.235,2.235,0,1,1,4.471,0,.213.213,0,0,0,.426,0,2.235,2.235,0,1,1,4.471,0,.213.213,0,0,0,.426,0A2.664,2.664,0,0,0,252.6,350.742Zm-6.865-1.244a1.1,1.1,0,1,1,1.1,1.1,1.1,1.1,0,0,1-1.1-1.1Zm4.9,0a1.1,1.1,0,1,1,1.1,1.1A1.1,1.1,0,0,1,250.63,349.5Z",
    transform: "translate(-225.248 -318.269)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M68.872,124.021a.918.918,0,0,0-1.119-1.455l-1.892,1.4-1.25-1.683a3.209,3.209,0,0,0-2.227-1.42,2.014,2.014,0,1,0-2.361-.012,2.374,2.374,0,0,0-1.965,2.333V127.2a.888.888,0,0,0,.9.884.874.874,0,0,0,.458-.129v4.15a.213.213,0,1,0,.426,0v-8.18a.213.213,0,0,0-.426,0V127.2a.465.465,0,0,1-.93,0v-4.013a1.946,1.946,0,0,1,1.944-1.942h1.267a2.849,2.849,0,0,1,2.576,1.3l1.377,1.853a.213.213,0,0,0,.3.044L68,122.909a.492.492,0,0,1,.687.11.484.484,0,0,1-.085.672l-2.074,1.66a1.229,1.229,0,0,1-1.7-.169L63.64,123.76a.213.213,0,0,0-.373.136V132.1a.213.213,0,1,0,.426,0v-7.626l.819.975a1.657,1.657,0,0,0,2.292.228Zm-9.249-4.8a1.59,1.59,0,1,1,1.59,1.59,1.59,1.59,0,0,1-1.59-1.59Z",
    transform: "translate(-46.889 -97.118)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M243.317,102.716c0-.158-.367-.287-.821-.287h-8.335c-.454,0-.821.128-.821.287s.368.287.821.287H242.5C242.95,103,243.317,102.874,243.317,102.716Z",
    transform: "translate(1315.136 304.471)",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M242.653,137.487c0-.158-.424-.287-.947-.287h-7.418c-.523,0-.948.128-.948.287s.424.287.948.287h7.422C242.229,137.774,242.653,137.644,242.653,137.487Z",
    transform: "translate(1315.136 271.652)",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M233.626,172a.287.287,0,1,0,0,.574h1.743a.287.287,0,1,0,0-.574Z",
    transform: "translate(1315.136 238.804)",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x2: 24.737,
    transform: "translate(1536.107 400.642)",
    fill: "none",
    stroke: "#fafafa",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandard);
export default __webpack_public_path__ + "static/media/standard.18c806aae729fc439b1c70981ecdf2cb.svg";
export { ForwardRef as ReactComponent };